/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA ;
 */

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.announcements.publish],
        guard: getPermissionsGuard([{ resource: 'portal.announcements', scopes: ['publish'] }]),
        controller: () => import('./controllers/myAnnouncements')
    },
    {
        path: [config.routes.announcements.list],
        guard: getPermissionsGuard([{ resource: 'portal.announcements', scopes: ['view'] }]),
        controller: () => import('./controllers/announcements')
    },
    {
        path: [config.routes.announcements.new],
        guard: getPermissionsGuard([{ resource: 'portal.announcements', scopes: ['publish'] }]),
        controller: () => import('./controllers/myAnnouncement')
    },
    {
        path: [config.routes.announcements.edit],
        guard: getPermissionsGuard([{ resource: 'portal.announcements', scopes: ['publish'] }]),
        controller: () => import('./controllers/myAnnouncement')
    }
];
